import { computed, getCurrentInstance, onBeforeUpdate, ref, type ComputedRef, type Ref } from 'vue'

/** Presence, not value !== undefined, distinguishes a controlled field from a default value. */
export function useBoundValue<Props extends object, Key extends keyof Props & string>(props: Props, key: Key, local: Readonly<Ref<unknown>>): ComputedRef<Props[Key]> {
  const instance = getCurrentInstance()!
  const attr = key.replace(/([A-Z])/g, '-$1').toLowerCase()
  const isSupplied = () => Object.prototype.hasOwnProperty.call(instance.vnode.props ?? {}, key) || Object.prototype.hasOwnProperty.call(instance.vnode.props ?? {}, attr)
  const controlled = ref(isSupplied())
  onBeforeUpdate(() => { controlled.value = isSupplied() })
  return computed(() => controlled.value ? props[key] : local.value as Props[Key])
}
